export const API_BASE_URL =
  process.env.REACT_APP_API_URL ?? "http://localhost:8000";

export const endpoints = {
  clients: {
    base: "/clients",
    getAll: "/clients",
    search: (term?: string) => `/clients/search${term ? `?term=${term}` : ""}`,
    getOne: (reference: string) => `/clients/${reference}`,
    create: "/clients",
    update: (reference: string) => `/clients/${reference}`,
    delete: (reference: string) => `/clients/${reference}`,
    getSales: (reference: string) => `/sales/client/${reference}`,
  },
  products: {
    base: "/products",
    getAll: "/products",
    search: (params?: {
      search?: string;
      categoryReference?: string;
      brandReference?: string;
      page?: number;
      limit?: number;
    }) => {
      if (!params) return "/products";

      const queryParams = [];
      if (params.search)
        queryParams.push(`search=${encodeURIComponent(params.search)}`);
      if (params.categoryReference)
        queryParams.push(`categoryReference=${params.categoryReference}`);
      if (params.brandReference) queryParams.push(`brandReference=${params.brandReference}`);
      if (params.page) queryParams.push(`page=${params.page}`);
      if (params.limit) queryParams.push(`limit=${params.limit}`);

      return queryParams.length > 0
        ? `/products?${queryParams.join("&")}`
        : "/products";
    },
    getOne: (reference: string) => `/products/${reference}`,
    create: "/products",
    createBulk: "/products/bulk",
    update: (reference: string) => `/products/${reference}`,
    delete: (reference: string) => `/products/${reference}`,
  },
  categories: {
    base: "/categories",
    getAll: "/categories",
    search: (term?: string) =>
      `/categories/search${term ? `?term=${term}` : ""}`,
    getOne: (reference: string) => `/categories/${reference}`,
    create: "/categories",
    update: (reference: string) => `/categories/${reference}`,
    delete: (reference: string) => `/categories/${reference}`,
  },
  brands: {
    base: "/brands",
    getAll: "/brands",
    search: (term?: string) => `/brands/search${term ? `?term=${term}` : ""}`,
    getOne: (reference: string) => `/brands/${reference}`,
    create: "/brands",
    createBulk: "/brands/bulk",
    update: (reference: string) => `/brands/${reference}`,
    delete: (reference: string) => `/brands/${reference}`,
  },
  sales: {
    base: "/sales",
    getAll: "/sales",
    getOne: (reference: string) => `/sales/${reference}`,
    create: "/sales",
    getByClient: (clientReference: string) => `/sales/client/${clientReference}`,
  },
  messages: {
    base: "/messages",
    getByClient: (clientReference: string) => `/messages/client/${clientReference}`,
  },
  whatsapp: {
    base: "/whatsapp",
    status: "/whatsapp/status",
    webState: "/whatsapp/web/state",
    webEnsureCredential: "/whatsapp/web/ensure-credential",
    webStart: "/whatsapp/web/start",
    webLogout: "/whatsapp/web/logout",
  },
  bankingAccounts: {
    base: "/banking-accounts",
    getAll: "/banking-accounts",
    getOne: (reference: string) => `/banking-accounts/${reference}`,
    create: "/banking-accounts",
    update: (reference: string) => `/banking-accounts/${reference}`,
    delete: (reference: string) => `/banking-accounts/${reference}`,
    setDefault: (reference: string) => `/banking-accounts/${reference}/default`,
  },
  supplierProducts: {
    base: "/supplier-products",
    extract: "/supplier-products/extract",
    bulk: "/supplier-products/bulk",
    search: (term?: string) =>
      `/supplier-products/search${term ? `?term=${encodeURIComponent(term)}` : ""}`,
    getAll: (params?: {
      search?: string;
      supplierClientReference?: string;
      categoryReference?: string;
      page?: number;
      limit?: number;
    }) => {
      const queryParams: string[] = [];
      if (params?.search) queryParams.push(`search=${encodeURIComponent(params.search)}`);
      if (params?.supplierClientReference) {
        queryParams.push(`supplierClientReference=${params.supplierClientReference}`);
      }
      if (params?.categoryReference) {
        queryParams.push(`categoryReference=${params.categoryReference}`);
      }
      if (params?.page) queryParams.push(`page=${params.page}`);
      if (params?.limit) queryParams.push(`limit=${params.limit}`);
      return queryParams.length > 0
        ? `/supplier-products?${queryParams.join("&")}`
        : "/supplier-products";
    },
    getOne: (reference: string) => `/supplier-products/${reference}`,
    create: "/supplier-products",
    update: (reference: string) => `/supplier-products/${reference}`,
    delete: (reference: string) => `/supplier-products/${reference}`,
    updateOffer: (productReference: string, offerReference: string) =>
      `/supplier-products/${productReference}/offers/${offerReference}`,
    deleteOffer: (productReference: string, offerReference: string) =>
      `/supplier-products/${productReference}/offers/${offerReference}`,
  },
};
